export default __webpack_public_path__ + "Kuantum1.pdf";